import React from "react";
import styled from "styled-components";
import {FaUser} from "react-icons/fa";

const UploadBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
`;

const FileInputLabel = styled.label`
    background-color: green;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
    &:hover {
        background-color: darkgreen;
    }
`;

const HiddenFileInput = styled.input`
    display: none;
`;

const FileName = styled.p`
    font-size: 0.95rem;
    color: #aaa;
`;

const Image = ({fileName1, handleFileChange}) => {
    return (
        <UploadBox>
            <FileInputLabel htmlFor="demo-image-upload">
                <FaUser />
                <div style={{display: "flex", flexDirection: "column"}}>
                    <p> Upload Image Now</p>
                    <span style={{fontSize: "10px"}}>Maximum allowed is 5MB</span>
                </div>
            </FileInputLabel>
            <HiddenFileInput
                type="file"
                id="demo-image-upload"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "image")}
            />
            {fileName1 && <FileName>Selected: {fileName1}</FileName>}
        </UploadBox>
    );
};

export default Image;
